import React, { useState, useEffect } from "react";
import { Typography, Box, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import axios from "axios";

// Contenedor principal
const SliderContainer = styled(Box)({
  position: "relative",
  width: "100%",
  maxWidth: "900px",
  height: "auto",
  aspectRatio: "16/9",
  margin: "40px auto 0 auto",
  overflow: "hidden",
  borderRadius: "20px",
  boxShadow: "0 6px 25px rgba(0,0,0,0.25)",
});

// Cada slide
const Slide = styled("div")(({ index, activeIndex }) => ({
  position: "absolute",
  top: 0,
  left: `${(index - activeIndex) * 100}%`,
  width: "100%",
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  borderRadius: "20px",
  transition: "all 0.6s ease-in-out",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
}));

// Fondo semi-transparente detrás del texto
const TextOverlay = styled(Box)({
  backgroundColor: "rgba(0,0,0,0.4)",
  padding: "15px 20px",
  borderRadius: "12px",
  marginBottom: "20px",
  maxWidth: "90%",
});

// Botones izquierda/derecha
const Controls = styled(Box)({
  position: "absolute",
  top: "50%",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  transform: "translateY(-50%)",
  padding: "0 10px",
  boxSizing: "border-box",
});

// Dots de navegación
const Dots = styled(Box)({
  position: "absolute",
  bottom: "12px",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  gap: "8px",
});

const Dot = styled("div")(({ active }) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
  cursor: "pointer",
  transition: "all 0.3s ease",
  boxShadow: active ? "0 0 8px rgba(255,255,255,0.9)" : "none",
}));

export default function CarruselImagenHome() {
  const [slides, setSlides] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await axios.get("https://turismosanroman.com/turismobackend/public/api/slides");
        setSlides(response.data);
      } catch (error) {
        console.error("Error fetching slides:", error);
      }
    };
    fetchSlides();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        slides.length > 0 ? (prev + 1) % slides.length : 0
      );
    }, 4000);
    return () => clearInterval(interval);
  }, [slides]);

  const nextSlide = () => {
    setActiveIndex((prev) =>
      slides.length > 0 ? (prev + 1) % slides.length : 0
    );
  };

  const prevSlide = () => {
    setActiveIndex((prev) =>
      slides.length > 0 ? (prev === 0 ? slides.length - 1 : prev - 1) : 0
    );
  };

  return (
    <>
      <Box sx={{ textAlign: "center", mt: 6, mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            background:
              "linear-gradient(90deg, #01d9ffff, #2a3b87ff, #2cb5ebff)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "1px",
          }}
        >
          Descubre lo mejor del Turismo
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ 
            color: "#04184bff", 
            fontStyle: "bold", 
            mt: 1,
            letterSpacing: "1px",
          }}
        >
          Explora las maravillas de nuestra ciudad en un solo vistazo
        </Typography>
      </Box>

      <SliderContainer>
        {slides.map((slide, index) => (
          <Slide
            key={slide.id}
            index={index}
            activeIndex={activeIndex}
            style={{ backgroundImage: `url(${slide.image_url})` }}
          >
            <TextOverlay>
              {slide.title && (
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    letterSpacing: "1px",
                    color: "#fff",
                    textShadow: "2px 2px 6px rgba(0,0,0,0.7)",
                  }}
                >
                  {slide.title}
                </Typography>
              )}
              {slide.subtitle && (
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#fff",
                    textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
                  }}
                >
                  {slide.subtitle}
                </Typography>
              )}
            </TextOverlay>
          </Slide>
        ))}

        <Controls>
          <IconButton onClick={prevSlide} sx={{ color: "white" }}>
            <ArrowBackIosIcon />
          </IconButton>
          <IconButton onClick={nextSlide} sx={{ color: "white" }}>
            <ArrowForwardIosIcon />
          </IconButton>
        </Controls>

        <Dots>
          {slides.map((_, index) => (
            <Dot
              key={index}
              active={index === activeIndex}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </Dots>
      </SliderContainer>
    </>
  );
}
